import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import {
  responseLogWithNotification,
} from '../../../utils/utils';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import { getHistoryMaisEguById } from '../actions';
import Grid from '../../../components/base/Grid/Grid';
import {
  dateTimeFormatter, subjectFormatter, userFIOFormatter, userPositionFormatter, userShortFIOFormatter,
} from '../../../utils/formatters';
import { getApplicationData } from '../reducer';
import { errorNotification } from '../../Notifications/notificationDecorator';

export default function MaisEduHistoryDialog() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const maisEguNumber = searchParams.get('maisEguNumber');
  const procedure = searchParams.get('procedure');

  const {
    maisEguHistoryList,
    loadingMaisEguHistory,
  } = useSelector(getApplicationData);

  const loadData = opts => {
    const requestData = { maisEguNumber, procedure };
    const p1 = dispatch(getHistoryMaisEguById(requestData)).then(data => {
      if (data?.data && data?.data?.length === 0) {
        errorNotification('Запрос в МАИС ЭГУ', 'История изменений обращения отсутствует');
      }
    }).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const columns = [
    {
      dataField: 'settingDate',
      text: 'Дата и время',
      headerClassName: 'date-time-column',
      formatter: dateTimeFormatter,
      disableSort: true,
    },
    {
      dataField: 'operator',
      text: 'Оператор',
      headerClassName: 'user-column',
      formatter: userShortFIOFormatter,
      disableSort: true,
    },
    {
      dataField: 'operatorMFC',
      text: 'Уполномоченная организация',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'name',
      text: 'Статус',
      headerClassName: 'module-column',
      disableSort: true,
    },
  ];

  useEffect(() => { loadData(); }, []);

  const pageName = 'mais-history-dialog';

  return (
    <div className="sub-page-dialog ">
      <TimerLoader global loading={loadingMaisEguHistory} />
      <div className="page sub-page-container">
        <div className="page-title">
          <div className="title-text">История изменения обращения в МАИС ЭГУ</div>
        </div>
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="grid-wrapper frame">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <Grid
                  key={pageName}
                  data={maisEguHistoryList}
                  columns={columns}
                  name={`${pageName}-list`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
